<template>
    <div class="text-center">
        <div v-if="isLegalStatusLoading">
            <i class="fa fa-spinner fa-spin"></i>
        </div>
        <!-- START Owners -->
        <div v-else-if="realEstate && realEstate.legal_status && realEstate.legal_status.legal_file">
            <div v-for="(owner, owner_idx) in realEstate.legal_status.legal_owners" :key="'owner-'+owner_idx">
                {{owner.name}}
                <span class="label label-rouded" 
                    v-bind:class="owner.share.includes('1/1') ? 'label-success' : 'label-warning' "
                >
                    {{owner.share}}
                </span>
            </div>
            <div class="m-t-10">
                <span v-tooltip="$t('task_details:manage:zk_extract:view')"  
                    class="btn btn-xs btn-outline btn-rounded btn-info view-pdf "
                    v-if="realEstate.legal_status.legal_file"  
                    :href="realEstate.legal_status.legal_file"
                    :data-title="realEstate.legal_status.name"
                >
                    {{$t("task_details:manage:zk_extract")}}
                </span>
                <i class="fa fa-refresh text-info custom-cursor-pointer m-l-5" v-tooltip="$t('task_details:manage:zk_extract:get')" v-on:click.prevent="getLegalStatus"></i>
            </div>
        </div>
        <div v-else-if="realEstate && realEstate.legal_status && !realEstate.legal_status.does_exist">
            ZK izpisek ne obstaja
            <i class="fa fa-refresh text-info custom-cursor-pointer m-l-5" v-tooltip="$t('task_details:manage:zk_extract:get')" v-on:click.prevent="getLegalStatus"></i>
        </div>
        <div v-else>
            <span
                v-tooltip="$t('task_details:manage:zk_extract:get')"  
                class="btn btn-xs btn-outline btn-rounded btn-info"
                v-on:click.prevent="getLegalStatus"
            >
                {{$t("task_details:manage:zk_extract:get")}}
            </span>
        </div>
        <!-- END Owners -->
    </div>
</template>

<script>
import store from "../store";

export default {
    name: "LegalStatusDisplay",
    props: {
        realEstate: {
            type: Object,
            default: null
        },
        reKey: {
            type: String,
            required: true
        }
    },
    computed: {
        isLegalStatusLoading() {
            return store.getters.isLegalStatusLoading(this.reKey);
        }
    },
    methods: {
        getLegalStatus() {
            this.$emit("get-legal-status", this.reKey);
        }
    }
}
</script> 